import { BoxStyled } from './styles';

export default BoxStyled;
